const charCounters = document.querySelectorAll('.char-counter-textarea, .char-counter-textarea-short, .char-counter-textarea-long');

charCounters.forEach(function(charCounter) {
    const textAreaArray = [
        charCounter.querySelector('.comments'),
        charCounter.querySelector('.short-desc'),
        charCounter.querySelector('.long-desc')
    ];
    
    textAreaArray.forEach(function(textarea) {
        if (textarea) {
            textarea.addEventListener('input', function() {
                let counter = charCounter.querySelector('.counter');
                updateCharCounter(textarea, counter);
            });
        }
    });
});

function updateCharCounter(textarea, counterElement) {
    const maxLength = textarea.getAttribute('maxlength');
    const currentLength = textarea.value.length;
    counterElement.textContent = `${currentLength}/${maxLength} tegn`;
}